import { render, staticRenderFns } from "./FooterTutorial.vue?vue&type=template&id=8f012238"
import script from "./FooterTutorial.vue?vue&type=script&lang=js"
export * from "./FooterTutorial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports